import { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAlignJustify,
    faArrowRight,
    faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";

import { Modal } from "react-bootstrap";

import Listagem from "./Listagem";
import Cadastro from "./Cadastro";
import { useUserInfor } from "../../../../../../Context/User";
import { IModuloComCategorias } from "../../../../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import { IEmpreendimento } from "../../../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import { ListarEmpreendimentosController } from "../../../../../../Controllers/Geral/Produtos/ProdutosControllers";

export function SubCategoria() {
    const [lstEmpreendimento, setLstEmpreendimento] = useState<
        Array<IEmpreendimento>
    >([]);
    const [lstModulos] = useState<Array<IModuloComCategorias>>(
        useUserInfor().OrgInfor.MODULOS || []
    );

    useEffect(() => {
        ListarEmpreendimentosController().then(setLstEmpreendimento);
    }, []);

    return (
        <div className="tab-content">
            <div
                className="tab-pane fade active show"
                id="ListagemSubCategorias"
                role="tabpanel"
                aria-labelledby="ListagemSubCategorias"
            >
                <Listagem
                    lstModulos={lstModulos}
                    lstEmpreendimento={lstEmpreendimento}
                />
            </div>
            <div
                className="tab-pane fade"
                id="CadastroSubCategoria"
                role="tabpanel"
                aria-labelledby="CadastroSubCategoria"
            >
                <Cadastro
                    lstModulos={lstModulos}
                    lstEmpreendimento={lstEmpreendimento}
                />
            </div>
        </div>
    );
}

export function SubCategoriaHeader() {
    return (
        <>
            <Modal.Title
                id="contained-modal-title-vcenter"
                className="card-title"
            >
                <h3 className="card-label">
                    <FontAwesomeIcon icon={faArrowRight} className="mr-2" />
                    Subcategoria
                </h3>
            </Modal.Title>
            <div className="card-toolbar">
                <ul
                    className="nav nav-tabs nav-bold nav-tabs-line"
                    role="tablist"
                    id="#SubCategoriaHeaderTools"
                >
                    <li className="nav-item">
                        <a
                            className="nav-link active"
                            href="#ListagemSubCategorias"
                            data-toggle="tab"
                            data-target="#ListagemSubCategorias"
                            role="tab"
                        >
                            <span className="nav-icon">
                                <FontAwesomeIcon icon={faAlignJustify} />
                            </span>
                            <span className="nav-text">Listagem</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#CadastroSubCategoria"
                            data-toggle="tab"
                            data-target="#CadastroSubCategoria"
                        >
                            <span className="nav-icon">
                                <FontAwesomeIcon icon={faPlusCircle} />
                            </span>
                            <span className="nav-text">Cadastro</span>
                        </a>
                    </li>
                </ul>
            </div>
        </>
    );
}
